import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=1978799c&scoped=true&"
var script = {}
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=1978799c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978799c",
  null
  
)

export default component.exports